import { render, staticRenderFns } from "./footer-bar.vue?vue&type=template&id=35ba3e68&scoped=true&"
import script from "./footer-bar.vue?vue&type=script&lang=js&"
export * from "./footer-bar.vue?vue&type=script&lang=js&"
import style0 from "./footer-bar.vue?vue&type=style&index=0&id=35ba3e68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba3e68",
  null
  
)

export default component.exports